import { NAME } from './constants';

export const BULK_UPDATE_ITEMS = `${NAME}/BULK_UPDATE_ITEMS`;
export const BULK_UPDATE_ITEMS_FAILURE = `${NAME}/BULK_UPDATE_ITEMS_FAILURE`;
export const BULK_UPDATE_ITEMS_SUCCESS = `${NAME}/BULK_UPDATE_ITEMS_SUCCESS`;

export const FETCH_ITEMS = `${NAME}/FETCH_ITEMS`;
export const FETCH_ITEMS_FAILURE = `${NAME}/FETCH_ITEMS_FAILURE`;
export const FETCH_ITEMS_SUCCESS = `${NAME}/FETCH_ITEMS_SUCCESS`;

export const FETCH_BRANDS = `${NAME}/FETCH_BRANDS`;
export const FETCH_BRANDS_FAILURE = `${NAME}/FETCH_BRANDS_FAILURE`;
export const FETCH_BRANDS_SUCCESS = `${NAME}/FETCH_BRANDS_SUCCESS`;

export const FETCH_PANELS_IDS = `${NAME}/FETCH_PANELS_IDS`;
export const FETCH_PANELS_IDS_FAILURE = `${NAME}/FETCH_PANELS_IDS_FAILURE`;
export const FETCH_PANELS_IDS_SUCCESS = `${NAME}/FETCH_PANELS_IDS_SUCCESS`;

export const OPEN_MODAL = `${NAME}/OPEN_MODAL`;
